import { Flex, ListItem } from '@chakra-ui/react';
import { Link } from 'components/shared/Link';
import React from 'react';
import { StyledList } from './StyledList';
import { Title } from './Title';

export const ProductMaintenanceNotice = React.memo(() => {
  return (
    <Flex id="產品保養須知" flexDirection="column">
      <Title>產品保養須知</Title>
      <StyledList>
        <ListItem>
          德國寶產品保用需於貨到10天內，寄回保用登記證或到網址
          <Link
            href="https://www.germanpool.com/chi/warranty/form.php"
            target="_blank"
            wordBreak={{ base: 'break-all', md: 'break-word' }}
          >
            https://www.germanpool.com/chi/warranty/form.php
          </Link>
          &nbsp;登記資料，免費保用方正式生效。
        </ListItem>
        <ListItem>
          如對以上產品有任何查詢，可致電德國寶客戶服務熱線：
          <Link href="tel:+85227732888">2773 2888</Link>
        </ListItem>
      </StyledList>
    </Flex>
  );
});
